import { toast } from 'react-hot-toast'

export const handleError = (error: any, fallbackErrorMessage?: string) => {
  const errorMessage =
    error?.message || fallbackErrorMessage || 'Something went wrong'

  toast.error(errorMessage, { duration: 3000 })
}
